import React, { CSSProperties } from 'react';
import { IconInfoSolid } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import { cx } from '@emotion/css';
import styled from '@emotion/styled';

import { Price } from '@common/components';
import { Typography } from '@common/styles';

import { LegacyRow as Row } from '../layouts/LegacyRow';

interface Props {
  label: string;
  prefixPrice?: string;
  price: number;
  priceColor?: string;
  style?: CSSProperties;
  tooltip?: React.ReactNode;
  onClickInfo?: () => void;
}

export const PriceSummaryRow: React.FC<React.PropsWithChildren<Props>> = ({
  label,
  prefixPrice,
  price,
  priceColor,
  style,
  tooltip,
  onClickInfo,
}) => {
  return (
    <StyledRow style={style}>
      <Label className={Typography.BODY_14_REGULAR}>
        {label}
        {Boolean(onClickInfo) && (
          <Info>
            <IconInfoSolid onClick={onClickInfo} v3Color='gray200' width={24} height={24} />
            {tooltip}
          </Info>
        )}
      </Label>
      <Price
        className={cx('price', Typography.BODY_15_SEMIBOLD)}
        prefix={prefixPrice}
        price={price}
        color={priceColor}
      />
    </StyledRow>
  );
};

const StyledRow = styled(Row)<{ style?: React.CSSProperties }>`
  ${({ style }) => style && { ...style }};
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 18px;

  .price {
    letter-spacing: 0;
  }
`;

const Label = styled.span`
  display: flex;
  align-items: center;
  color: ${vars.v3Color.gray900};
`;

const Info = styled.span`
  position: relative;
  height: 24px;
`;
